<div class="note-display" (click)="onNoteClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>sticky_note_2</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <span class="note-title" [innerHTML]="result.label"></span>
    </div>
    <div class="result-meta">
      <span *ngIf="result.info?.owner">by {{ result.info.owner }}</span>
    </div>
  </div>
</div>
